// API configuration
const API_BASE_URL = 'https://branded-mark-api.stephen-edginton.workers.dev';

export interface WaitlistFormData {
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  role: string;
  message: string;
}

export interface WaitlistResponse {
  success: boolean;
  message: string;
  id?: number;
  error?: string;
}

export interface WaitlistEntry {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  role: string;
  message: string;
  createdAt: string;
}

export interface WaitlistListResponse {
  data: WaitlistEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

/**
 * Submit a waitlist signup
 */
export async function submitWaitlistSignup(data: WaitlistFormData): Promise<WaitlistResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/waitlist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || 'Failed to submit waitlist signup');
    }

    return result;
  } catch (error) {
    console.error('Waitlist signup error:', error);
    throw error;
  }
}

/**
 * Get waitlist entries (for admin purposes)
 */
export async function getWaitlistEntries(page: number = 1, limit: number = 50): Promise<WaitlistListResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/waitlist?page=${page}&limit=${limit}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || 'Failed to fetch waitlist entries');
    }

    return result;
  } catch (error) {
    console.error('Get waitlist entries error:', error);
    throw error;
  }
}

/**
 * Check API health
 */
export async function checkApiHealth(): Promise<{ status: string; timestamp: string }> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    const result = await response.json();
    
    if (!response.ok) {
      throw new Error('API health check failed');
    }
    
    return result;
  } catch (error) {
    console.error('API health check error:', error);
    throw error;
  }
} 